<template>
    <uiv-btn class="tb__refresh-button" :style="btnStyle" @click.stop="refresh"><i class="glyphicon glyphicon-refresh"></i>Refresh </uiv-btn>
</template>
<script>
    export default {
      props:{
        btnStyle: {required: false, default:'', type: String},

      },
      methods:{
        refresh(){
          this.$emit('refresh');
        }
      }
    }
</script>
<!--<script lang="ts">-->
    <!--import {EventBus,Messages} from '../../services/EventBus';-->
    <!--import Component from 'vue-class-component'-->
    <!--import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'-->

    <!--@Component()-->
    <!--class RefreshButton extends Vue{-->

        <!--@Prop({required: false})-->
          <!--btnStyle?: string;-->

        <!--@Emit(<string>Messages.GenericRefresh)-->
        <!--refresh(){-->
        <!--}-->

    <!--}-->
         <!--export default RefreshButton;-->
<!--</script>-->

<style scoped>

</style>